export const API_PATH_ApiTrafficStudyPostVote = '/services/traffic-studies/apiTrafficStudyPostVote';
